import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import styled, { css } from 'styled-components';
import { pxToRems, breakpoints, } from '@awaze/design-system.utils.react';
import createTheme from 'styled-variants';
const fallbackFonts = 'Helvetica, Arial, sans-serif';
export const defaultSizes = {
    p: 300,
    h1: 600,
    h2: 500,
    h3: 400,
    h4: 300,
    h5: 200,
    h6: 100,
};
const TextTheme = createTheme('Text');
const TextThemed = styled.p(TextTheme);
const createFontStyles = ({ tokenPrefix, size, mappedType, theme }) => {
    return css `
    font-family: ${theme[`${tokenPrefix}${size}${mappedType}FontFamily`]},
      ${fallbackFonts};
    font-size: ${pxToRems(theme[`${tokenPrefix}${size}${mappedType}FontSize`])};
    font-weight: ${theme[`${tokenPrefix}${size}${mappedType}FontWeight`]};
    letter-spacing: ${pxToRems(theme[`${tokenPrefix}${size}${mappedType}LetterSpacing`])};
    line-height: ${pxToRems(theme[`${tokenPrefix}${size}${mappedType}LineHeight`])};
  `;
};
export const TextStyled = styled(TextThemed) `
  margin-top: 0;
  margin-right: 0;
  margin-bottom: ${({ mb }) => mb && `${pxToRems(mb)}`};
  margin-left: 0;

  color: ${({ theme, color }) => theme[color]};

  ${({ isHeading, sizes, theme, type }) => {
    if (!sizes && !type) {
        return null;
    }
    sizes = isHeading && !sizes ? 600 : !isHeading && !sizes ? 300 : sizes;
    type = !type ? 'regular' : type;
    const size = sizes[0] || sizes;
    const sizesIsArray = Array.isArray(sizes);
    const typeMap = {
        regular: '',
        mid: 'Mid',
        bold: 'Bold',
    };
    const mappedType = typeMap[type];
    const tokenPrefix = isHeading ? 'FontHeadingHeading' : 'FontTextText';
    return css `
      ${createFontStyles({ tokenPrefix, size, mappedType, theme })}

      ${sizesIsArray &&
        css `
        @media screen and (min-width: ${breakpoints[0]}px) {
          ${createFontStyles({
            tokenPrefix,
            size: sizes[1],
            mappedType,
            theme,
        })}
        }

        @media screen and (min-width: ${breakpoints[1]}px) {
          ${createFontStyles({
            tokenPrefix,
            size: sizes[2],
            mappedType,
            theme,
        })}
        }
      `}
    `;
}}
`;
/**
 * A component to control font size and style for text based elements.
 *
 * This component should be used for any typography uses that aren't headings including `p`, `small`, `blockquote`, `pre`, `b`, `strong`, `em` and more.
 *
 */
export const Text = memo(({ as = 'p', children, className, sizes, type, mb = 0, color = 'currentColor', ...rest }) => {
    const elementName = as.toString();
    const isHeading = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(elementName);
    const defaultSize = defaultSizes[elementName];
    return (_jsx(TextStyled, { as: as, className: className, isHeading: isHeading, sizes: sizes !== undefined ? sizes : defaultSize, type: type, mb: mb, color: color, ...rest, children: children }));
});
//# sourceMappingURL=text.js.map